import { Flex } from "@repo/ui";
import { ActivityLogSearchSection } from "../features/activityLogSearch/ActivityLogSearchSection";
import { DirectoryAdminSection } from "../features/directoryAdmin/DirectoryAdminSection";

/**
 * Admin-only tools, gated in App.tsx: the provider directory editor and
 * activity log search.
 */
export function AdminRoute() {
	return (
		<Flex column flex background="sand1" padding="xl" overflow="y">
			<Flex column gap="xxl" style={{ width: "100%", maxWidth: "720px" }}>
				<DirectoryAdminSection />
				<Flex borderTopWidth="md" borderColor="sandA5" />
				<ActivityLogSearchSection />
			</Flex>
		</Flex>
	);
}
